// extracted by mini-css-extract-plugin
export default {"content":"ContentWrapper_content__AWs6z","content_80":"ContentWrapper_content_80__8Rvu8"};